export default {
    relationshipRuleCategory: []
}
